import { createFileRoute } from "@tanstack/react-router";
import AdminCRM from "@/pages/admin/AdminCRM";

export const Route = createFileRoute("/admin/crm/")({ component: AdminCRM });
